export default __webpack_public_path__ + "static/media/logo.2ea000d8.png";